import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../providers/services/utils.service';

export class BaseFragmentComponent {
  constructor(private activatedRoute: ActivatedRoute, private utilsService: UtilsService, private document) { }

  initScrollBehavior() {
    this.activatedRoute.fragment.subscribe(newFragment => {
      if (newFragment && this.utilsService.isPlatformBrowser) {
        setTimeout(() => {
          const elementY = this.document.getElementById(newFragment).getBoundingClientRect().top;
          const navbarY = this.document.getElementById('navbar').offsetHeight;
          window.scroll({ left: 0, top: elementY + window.scrollY - navbarY });
        }, 500);
      }
    });
  }
}
